<template>
  <div>
    <PdfHomeHeader>
      <!-- 广播消息 -->
      <MessageBroad
        v-if="isShowMessageBroad && !isVip"
        :messageBroadList="messageBroadList"
        @closeMessageBroad="closeMessageBroad"
      />

      <div :class="{ noScroll: isNoScroll, topDistance: isShowMessageBroad }">
        <PdfCommonPayModule
          v-if="memberShow"
          :chargeType="payPackageGroupId"
          @changePay="changePay"
          @login="loginReport"
          @changeRenew="changeRenew"
          @toXieyi="toXieyi"
          @changePayType="changePayType"
          @toAliPay="changePayType"
          @paySuccess="paySuccess"
          no-refresh
        />

        <template
          v-if="isShowInterests"
        >
          <NewInterests
            v-if="isShowComment === AbTestEnum.ATest"
            @setScrollPosition="setScrollPosition"
            @report="reportInterestsShow"
          />
          <InterestAndComment
            v-else
            :show-comment="isShowComment"
          />
        </template>

        <ToTop @to_top="toTop" />
      </div>
    </PdfHomeHeader>
  </div>
</template>
<script>
import PdfCommonPayModule from '@/components/common/PdfCommonPayModule.vue'
import PdfHomeHeader from '@/components/PdfHomeHeader'
import ToTop from '@/components/common/ToTop'
import NewInterests from '@/components/NewInterests.vue'
import InterestAndComment from '@/components/commentModule/InterestAndComment.vue'
import MessageBroad from '@/components/activity/MessageBroad.vue'

import { mapGetters } from 'vuex'
import client from '@/client/'
import { getActConfig } from '@/api/act'
import homeMixin from '@/mixins/homeMixin.js'
import { reportPerformance, easyCounterReport } from '@/utils/report'
import { AbTestEnum } from '@/services/home/home.ts'
import { getCommentInfoAbTestRequest, getMessageBroadList } from '@/api/user'
import { DOMAIN_RELATED, AB_LIST } from '@/config/dataMap'
import { getMessageBroadcastTime, setMessageBroadcastTime } from '@/utils/localStorage'

export default {
  name: 'PdfHome',
  components: {
    ToTop,
    PdfHomeHeader,
    PdfCommonPayModule,
    NewInterests,
    InterestAndComment,
    MessageBroad,
  },
  mixins: [homeMixin],
  data () {
    return {
      isNoScroll: false,
      AbTestEnum: AbTestEnum,
      isShowComment: AbTestEnum.ATest, // 是否展示评论模块（默认不展示）
      isShowInterests: false, // 是否展示权益，AB请求完成再展示
      messageBroadList: [], // 消息广播列表
      isShowMessageBroad: false, // 是否展示消息广播
    }
  },
  computed: {
    ...mapGetters([
      'isMember',
      'isPdfMember',
      'loginStatus',
      'openId',
      'token',
      'userInfo',
      'isContinuous',
      'isPdfLifeMember'
    ]),
    // 是否会员（极光普通会员 | 终身会员 | 毒霸会员）
    isVip () {
      return this.isPdfMember || this.isPdfLifeMember || this.isMember
    },
    memberShow () {
      if (this.isVip) {
        return false
      }
      return true
    },
    /**
     * 套餐组Id
     */
    payPackageGroupId () {
      return [152]
    }
  },
  watch: {},
  created () {
    Promise.all([
      this.getCommentInfoAbTest(),
      this.isRequestMessageBroad()
    ])

    // 会员中心展示成功上报 - easyCounter
    easyCounterReport('home_page_load_success')
  },
  mounted () {
    // 关闭前上报停留时间
    window.onbeforeunload = () => {
      const stay_time = parseInt(
        (new Date().getTime() - performance.timing.fetchStart)
      )
      this.report({ click: 7, stay_time: stay_time })
      localStorage.setItem('pdf-home-stay-time', stay_time)
    }
    // 打开续费窗口
    if (this.isShowRenewal(this.$route.query.renewal)) {
      const useCoupon = this.$route.query.useCoupon
      client.common.API.client_openOptionWindow({
        url: useCoupon ? `${DOMAIN_RELATED.domain}${DOMAIN_RELATED.channel}/renewal?useCoupon=1` : `${DOMAIN_RELATED.domain}${DOMAIN_RELATED.channel}/renewal`,
        width: 688,
        height: 490,
        open_opction: 19,
      })
      // 修改 renewal ，避免重复触发打开续费窗口
      this.$router.replace({
        query: { ...this.$route.query, renewal: 0 }
      })
    }
    // 跳转到滚动条的位置
    this.goToScrollPosition()
    this.$EventBus.$on('showPay', () => {})
    this.report({})
    reportPerformance()
  },
  methods: {
    isShowRenewal (renewal) {
      return Number(renewal || 0) === 1
    },
    paySuccess () {
      this.refresh({
        token: this.token,
        open_id: this.openId,
        webRefresh: 1
      })
    },

    // 获取用户评论AB测数据
    getCommentInfoAbTest () {
      getCommentInfoAbTestRequest({ ab_name_list: AB_LIST.COMMENT_AB_LIST }).then(res => {
        if (res.resp_common.ret === 0 && res.strategy_list.length > 0 && res.strategy_list[0].payload.type != undefined) {
          this.isShowComment = res.strategy_list[0].payload.type
        }
        this.isShowInterests = true
      })
    },

    // 判断是否请求消息广播
    isRequestMessageBroad () {
      const messageBroadTime = getMessageBroadcastTime()
      const nowTime = Date.now() // 当前时间戳
      const oneDay = 24 * 60 * 60 * 1000 // 24小时时间戳
      const diff = nowTime - messageBroadTime

      // 规避会员用户
      if (!this.isVip && ((messageBroadTime && diff > oneDay) || !messageBroadTime)) {
        this.getMessageBroadInfo()
      }
    },

    // 请求消息广播信息
    getMessageBroadInfo () {
      getMessageBroadList().then(res => {
        if (res.resp_common.ret === 0) {
          this.isShowMessageBroad = res.enable
          this.messageBroadList = res.broadcast_list
        }
      })
    },

    // 关闭消息广播
    closeMessageBroad () {
      this.isShowMessageBroad = false
      setMessageBroadcastTime(Date.now().toString())
    },
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/homeMixin.scss';
.topDistance {
  margin-top: 26px;
}
</style>
